import styled from 'styled-components';
import DialogSimple from '../commons/Basic/Dialog/DialogSimple';

export const DialogDS = styled(DialogSimple)`
  width: auto;
  max-height: 100%;
  overflow: hidden;
  padding-bottom: 0;
  margin: 0;

  @media (max-width: 450px) {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    margin: 0;
  }
`;

export const DialogNoPadding = styled(DialogDS)`
  padding: 0;
`;

export const DialogBodyContainer = styled.div`
  width: 100%;
  padding: 5px;
  height: calc(100% - 45px);
  overflow-y: auto;
  overflow-x: hidden;
`;

interface IButtonsEndsContainers {
  alignIcons?: string;
  justifyIcons?: string;
}

export const DialogButtonsEndsContainers = styled.div`
  padding: 6px;
  display: flex;
  align-items: ${(props: IButtonsEndsContainers) => (props.alignIcons ? props.alignIcons : 'end')};
  justify-content: ${(props: IButtonsEndsContainers) => (props.justifyIcons ? props.justifyIcons : 'flex-end')};
  margin-left: -10px;
  margin-right: -10px;
  height: 45px;
  background-color: rgba(235, 236, 237, 0.41);
  border-top: 1px solid rgba(235, 236, 237, 0.71);
`;
